import { Schema, string } from "yup";

import { passwordREGEX } from "../utils/serviceUtils";

export const passwordValidationMessage =
	"The password must contain at least 8 characters, 1 uppercase letter, 1 lowercase letter and 1 number and 1 special character.";
export const passwordMatch = (): Schema => string().matches(passwordREGEX, passwordValidationMessage);
